import styled from 'styled-components';

const StepContainer = styled.div`
  width: 100%;
`;

const StepRow1 = styled.div`
  display: flex;
  flex-direction: row-reverse;
  text-align: left;
  line-height: 16px;
  padding-top: 16px;
  padding-right: 16px;
  padding-left: 16px;
  padding-bottom: 2px;
  font-size: 12px;
  color: #4f6168;
  font-family: Lato;
  font-style: normal;

  .boulderText {
    font-weight: 900;
  }

  .fractionText {
    font-weight: 400;
  }
`;

const StepRowText = styled.div`
  width: 100%;
  color: #161d1f;
  font-family: Lato;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  padding: 0px 16px;
`;

// FIN COMPONENTS FOR JOYRIDE NUEVOS ESTILOS

const Container = styled.div.attrs((props: any) => ({
  paddingZero: props.paddingZero || false
}))`
  padding: 0 ${(props) => (props.paddingZero ? '0' : '16')}px;

  @media (min-width: 640px) {
    padding: 0px 16px;
  }
  @media (min-width: 768px) {
    padding: 0 24px;
  }

  @media (min-width: 992px) {
    padding-left: 120px;
    padding-right: 32px;
  }

  @media (min-width: 1280px) {
    width: 1128px;
    // margin-left: 120px;
    padding: 0px;
  }
`;

const WrapperContainer = styled.div`
  @media (min-width: 1280px) {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 90px;
  }
`;

const SectionCardTitle = styled.div`
  display: flex;
  gap: 16px;
  height: 40px;
  justify-content: space-between;
  align-items: center;
  // margin-bottom: 16px;
  margin-top: 32px;

  @media (min-width: 768px) {
    margin-top: 40px;
    justify-content: flex-start;
  }

  @media (min-width: 992px) {
    margin-top: 0;
    margin-bottom: 0;
    justify-content: flex-start;
  }
`;

const Title = styled.h2`
  color: #161d1f;
  font-size: 20px;
  line-height: 28px;
  height: 24px;
  // font-weight: 700;
`;

const Button = styled.button`
  background: #5b36f2;
  border-radius: 4px;
  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  width: 130px;
  height: 40px;
  border: none;
  cursor: pointer;

  &:hover {
    background: #745ef6;
  }

  &:focus,
  active {
    background: #4318cd;
  }
`;

const SectionCardContainer = styled.div.attrs((props: any) => ({
  dataLength: props.dataLength
}))`
  height: 100%;
  background: #ffffff;
  box-shadow: 0px 1.2px 4px #eaeef1;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  // justify-content: space-around;
  padding: 16px 16px;
  gap: 24px;

  @media (min-width: 640px) {
    ${(props) =>
      props.dataLength !== 0
        ? `display: grid;
        grid-template-columns: repeat(${props.dataLength}, 1fr);
        width: ${props.dataLength === 1 ? 57 : 100}%;
        padding: ${props.dataLength === 1 ? '16px 9px' : '16px 16px'};
        `
        : `display:flex`};
    gap: 16px;
  }

  @media (min-width: 992px) {
    ${(props) =>
      props.dataLength !== 0
        ? `display: grid;
        grid-template-columns: repeat(${props.dataLength}, 1fr);
        width: ${props.dataLength === 1 ? 55 : 100}%;
        `
        : `display:flex`};
  }

  .container__courses--blank {
    width: 100%;
    display: flex;
    gap: 16px;
    align-items: center;
  }

  .container__courses--blank > h1 {
    font-weight: 500;
    font-size: 18px;
    line-height: 28px;
    color: #161d1f;
  }
`;

const Tramite = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (min-width: 768px) {
    gap: 24px;
  }

  @media (min-width: 992px) {
    grid-area: area2;
    gap: 24px;
  }
`;

const TramiteCardTitle = styled.div`
  display: flex;
  gap: 16px;
  height: 40px;
  justify-content: space-between;
  align-items: center;

  @media (min-width: 768px) {
    justify-content: flex-start;
  }

  @media (min-width: 992px) {
    justify-content: flex-start;
  }
`;

const TramiteCardParaphap = styled.div`
  color: #161d1f;
  font-weight: 900;
  font-size: 18px;
  line-height: 28px;
  /* width: 205px; */
`;

const TramiteCardContainer = styled.button`
  background: #ffffff;
  display: flex;
  height: 112px;
  box-shadow: 0px 1.2px 4px #eaeef1;
  border-radius: 8px;
  padding: 16px 8px 16px 16px;
  align-items: center;
  gap: 16px;

  &:hover {
    cursor: pointer;
    background: #e1edf4;
  }

  &:focus,
  active {
    background: #a8cbe2;
  }
`;

const BlockTramite = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: flex-start;
  /* width: 168px; */
  height: 74px;
  width: 100%;
`;

const TramiteCardImgen = styled.img``;

const TramiteTitle = styled.p`
  color: #161d1f;
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;

  text-align: start;

  @media (min-width: 768px) {
    color: #283044;
  }

  @media (min-width: 1920px) {
    color: #161d1f;
  }
`;
const TramiteSubTitle = styled.p`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #4f6168;
`;

const TramiteCardIcon = styled.img`
  margin: 20px;
`;

const SectionCourse = styled.div`
  margin-top: 24px;
  display: grid;
  // gap: 6px;
  /* width: 328px; */
  width: 100%;

  @media (min-width: 640px) {
    margin-top: 40px;
  }

  @media (min-width: 768px) {
    gap: 24px;
  }
`;

const TitleCourse = styled.h2`
  height: 28px;
  /* width: 254px; */
  font-weight: 900;
  font-size: 18px;
  line-height: 28px;
  color: #161d1f;
`;
const CardCourse2 = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  grid-template-columns: repeat(1, 1fr);

  @media (max-width: 360px) {
    grid-template-columns: repeat(1, 1fr);
  }

  @media (min-width: 992px) {
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
    grid-template-columns: repeat(1, 1fr);
    gap: 24px;
    display: flex;
    // width: 100%;
    align-items: self-start;
    display: flex;
  }
`;

const ImageBookmark = styled.img``;

const BlockCourse = styled.button`
  display: flex;
  height: 113px;
  flex-direction: column;
  justify-content: center;
  box-shadow: 0px 1.2px 4px #eaeef1;
  border-radius: 4px;
  align-items: center;
  padding: 8px 16px;
  background: #ffffff;
  cursor: pointer;
  width: 264px;

  &:hover {
    background: #d5e5f0;
  }

  &:focus,
  active {
    background: #a8cbe2;
  }
  // @media (min-width: 640px) {
  //   width: 292px;
  // }
  // @media (min-width: 768px) {
  //   width: 300px;
  // }
  @media (min-width: 992px) {
    // width: 100%;
    // width: 264px;
  }
`;

const ParagraphCourse = styled.p`
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #1a055d;
  text-align: center;
  margin-top: 10px;
`;

const SectionInterests = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 25px;
  width: 100%;
`;

const InterestsTitle = styled.h1`
  font-weight: 900;
  font-size: 18px;
  line-height: 28px;
  color: #161d1f;
`;

const RowCardInterests = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  overflow: auto;
  gap: 24px;

  ::-webkit-scrollbar {
    display: none;
  }
`;

interface CardInterestsProps {
  height?: string;
  width?: string;
}

const CardInterests = styled.button<CardInterestsProps>`
  box-shadow: 0px 1.2px 4px #eaeef1;
  border-radius: 4px;
  background: #ffffff;
  display: flex;
  padding: 16px 8px;
  height: ${(props) => props.height ?? '88px'};
  gap: 10px;
  width: ${(props) => props.width ?? '264px'};

  &:hover {
    background: #d5e5f0;
  }

  &:focus,
  active {
    background: #a8cbe2;
  }
`;

interface ImagenInterestsProps {
  height?: string;
  width?: string;
  margin?: string;
}

const ImagenInterests = styled.img<ImagenInterestsProps>`
  max-width: none;
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  margin: ${(props) => props.margin};
`;

const ContainerInterests = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
  justify-content: space-around;
`;

const ContainerInterestsExternal = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
  justify-content: space-around;
`;

const TitlesInterests = styled.div`
  display: flex;
  flex-direction: column;
  width: 182px;
  text-align: start;
`;

const TitlesInterestsExternal = styled.div`
  display: flex;
  flex-direction: column;
  width: 166px;
  text-align: start;
`;

interface TitleInterestsProps {
  size?: string;
  lineHeight?: string;
}

const TitleInterests = styled.h1<TitleInterestsProps>`
  font-weight: 700;
  font-size: ${(props) => props.size ?? '14px'};
  line-height: ${(props) => props.lineHeight ?? '20px'};
  color: #161d1f;
`;

const SubTitleInterests = styled.h1`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #4f6168;
  width: 100%;
`;

const ButtonIconLink = styled.div`
  width: 16px;
  display: flex;
  align-items: flex-start;
`;

const IconExternalLink = styled.img`
  width: 100%;
`;

const HeaderInitiation = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (min-width: 992px) {
    padding-left: 90px;
    display: grid;
    grid-templates-columns: 1fr;
    grid-templates-rows: repeat(3, 1fr);
    grid-template-areas:
      'titulo'
      'parrafo'
      'imagen'
      'areaMatricula';
  }
`;

const SectionMatricula = styled.div`
  display: block;
  width: 100%;
  flex-direction: column;
  padding: 24px 16px 0px 16px;
  grid-area: areaMatricula;

  .container__hero {
    width: 328px;
    background: #1a055d;
    border-radius: 4px;
    display: flex;
    flex-direction: row;
    padding: 16px;
    align-items: center;
    justify-content: space-between;
  }

  .hero {
    display: flex;
    gap: 8px;
  }

  p {
    font-weight: 900;
    font-size: 14px;
    line-height: 20px;
    color: #ffffff;
  }

  // ///////////////////

  @media (min-width: 992px) {
    p {
      font-weight: 700;
      font-size: 18px;
      line-height: 28px;
    }
    .container__hero {
      width: 395px;
    }
    padding: 24px 16px 0px 28px;
  }

  @media (min-width: 992px) {
    padding: 24px 32px 0px 32px;
  }

  @media (min-width: 1280px) {
    width: 1128px;
    padding-top: 24px;
    margin: 0 auto;
    padding-left: 0;
  }
`;

const SectionCard2 = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (min-width: 768px) {
    gap: 40px;
  }

  @media (min-width: 992px) {
    margin-top: 40px;
    margin-bottom: 40px;
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    gap: 24px;
    grid-template-areas:
      'area1 area1 area1 area1 area1 area1 area2 area2 area2 area2 area2 area2'
      'area3 area3 area3 area3 area3 area3 area3 area3 area3 area3 area3 area3';
  }
`;

const SectionShedule = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (min-width: 768px) {
    gap: 24px;
  }

  @media (min-width: 992px) {
    grid-area: area1;
    gap: 24px;
  }
`;

const SectionRol = styled.p`
  margin-top: -12px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #161d1f;

  @media (min-width: 768px) {
    margin-top: -24px;
    grid-area: area3;
  }

  @media (min-width: 992px) {
    margin-top: -12px;
    grid-area: area3;
  }
`;

const Wrapper = styled.div`
  background-color: #5b36f2;
  padding: 8px 16px;
  color: #fff;
  font-size: 18px;
  font-family: lato;
  line-height: 32px;
  b.modName {
    font-weight: 900;
  }
`;

export {
  StepContainer,
  StepRow1,
  StepRowText,
  Container,
  WrapperContainer,
  SectionCardTitle,
  Title,
  Button,
  SectionCardContainer,
  Tramite,
  TramiteCardTitle,
  TramiteCardParaphap,
  TramiteCardContainer,
  BlockTramite,
  TramiteCardImgen,
  TramiteTitle,
  TramiteSubTitle,
  TramiteCardIcon,
  SectionCourse,
  TitleCourse,
  CardCourse2,
  ImageBookmark,
  BlockCourse,
  ParagraphCourse,
  SectionInterests,
  InterestsTitle,
  RowCardInterests,
  CardInterests,
  ImagenInterests,
  ContainerInterests,
  TitlesInterests,
  TitleInterests,
  SubTitleInterests,
  ButtonIconLink,
  IconExternalLink,
  HeaderInitiation,
  SectionMatricula,
  SectionCard2,
  SectionShedule,
  SectionRol,
  ContainerInterestsExternal,
  TitlesInterestsExternal,
  Wrapper
};
